<canvas #canvas></canvas>

<div *ngIf="!agnostic_units" class="pack_container" id="pack">
	<div id="boxicon">
		<img [src]="'/assets/boxicon.svg'">
	</div>
	<p id="packbtn">Pack unit</p>
</div>
<div class="specials">
	<p *ngIf="unit.on_sale" class="one-day-only">
		<span>
			One day <b>only</b>
		</span>
	</p>
	<p *ngIf="unit.first_month_free">
		<img [src]="'/assets/1st-month-free.svg'">
		<span>
			1 month <b>Free</b>
		</span>
	</p>
	<p *ngIf="unit.one_month_half_price && !unit.three_month_half_price && !unit.first_month_free">
		<img [src]="'/assets/50-off-first-month.svg'">
		<span>
			<b>50% off</b> your first month!
		</span>
	</p>
	<p *ngIf="unit.three_month_half_price">
		<img [src]="'/assets/50-off-first-3-months.svg'">
		<span>
			<b>50% off</b> your&nbsp;first&nbsp;three&nbsp;months!
		</span>
	</p>
	<p *ngIf="unit.few_left && !unit.one_month_half_price && !unit.three_month_half_price && !unit.first_month_free">
		<b>Few left!</b>
	</p>
</div>

<div id="closebtn" (click)="close.emit()">
	<svg xmlns="http://www.w3.org/2000/svg" width="24.64" height="24.64" viewBox="0 0 35.177 35.177">
		<defs>
			<style>
				.z {
					fill: none;
					stroke: #2c874b;
					stroke-width: 5px;
				}
			</style>
		</defs>
		<g transform="translate(-284.161 -17.161)">
			<line class="z" x2="44.747" transform="translate(285.929 18.929) rotate(45)" />
			<line class="z" x2="44.747" transform="translate(285.929 50.57) rotate(-45)" />
		</g>
	</svg>
</div>


<nav>
	<div *ngIf="!agnostic_units" class="arrow-container">
		<p class="prev" (click)="next_emit(-1)" *ngIf="prev != null"></p>
		<div class="dimensions">{{arrow_dimensions}}: {{squared_dimensions}}m<sup>2</sup></div>
		<p class="next" (click)="next_emit(1)" *ngIf="next != null"></p>
	</div>
	<div *ngIf="!agnostic_units" class="unit-description">
		<p>{{unit.desc}}<ng-container *ngIf="!unit.parking && !!get_estimate(unit)"> | {{get_estimate(unit)}}</ng-container></p>

		<button (click)="quick_quote_click()">Quick Quote</button>
	</div>
</nav>

<div *ngIf="agnostic_units && show_menu" class="agnostic_view_menu">
	<h3 class="heading">Find the right unit size </h3>
	<p class="sub-heading">Select an option below to explore our unit sizes:</p>
	<hr>

	<div class="category" [ngStyle]="{'border':(show_unit_size1)?'2px solid rgba(13, 135, 79,1)':'1px solid #c5c5c5'}">
		<p (click)="show_unit_size1 = !show_unit_size1" [ngStyle]="{'font-weight':(show_unit_size1)?'600':'400'}">Small
			units</p>
		<div *ngIf="show_unit_size1">
			<div class="content" (click)="set_index_change(0)"
				[ngStyle]="(style_index!=0)?default_styles:changed_styles">
				<p class="dim" [ngStyle]="(style_index!=0)?default_p_styles:changed_p_styles">,9 x ,9: 0.81m</p>
				<div *ngIf="style_index==0" class="description">{{description[0]}}</div>

				<div *ngIf="style_index==0" class="quick_quote">
					<p>Quick quote</p>
				</div>
			</div>
			<div class="content" (click)="set_index_change(1)"
				[ngStyle]="(style_index!=1)?default_styles:changed_styles">
				<p class="dim" [ngStyle]="(style_index!=1)?default_p_styles:changed_p_styles">1,3 x 1: 1.3m</p>
				<div *ngIf="style_index==1" class="description">{{description[1]}}</div>

				<div *ngIf="style_index==1" class="quick_quote">
					<p>Quick quote</p>
				</div>
			</div>
			<div class="content" (click)="set_index_change(2)"
				[ngStyle]="(style_index!=2)?default_styles:changed_styles">
				<p class="dim" [ngStyle]="(style_index!=2)?default_p_styles:changed_p_styles">1,5 x 2: 3m</p>
				<div *ngIf="style_index==2" class="description">{{description[2]}}</div>

				<div *ngIf="style_index==2" class="quick_quote">
					<p>Quick quote</p>
				</div>
			</div>
		</div>
	</div>

	<div class="category" [ngStyle]="{'border':(show_unit_size2)?'2px solid rgba(13, 135, 79,1)':'1px solid #c5c5c5'}">
		<p (click)="show_unit_size2 = !show_unit_size2" [ngStyle]="{'font-weight':(show_unit_size2)?'600':'400'}">Medium
			units</p>
		<div *ngIf="show_unit_size2">
			<div class="content" (click)="set_index_change(3)"
				[ngStyle]="(style_index!=3)?default_styles:changed_styles">
				<p class="dim" [ngStyle]="(style_index!=3)?default_p_styles:changed_p_styles">2 x 2: 4m </p>
				<div *ngIf="style_index==3" class="description">{{description[3]}}</div>

				<div *ngIf="style_index==3" routerLink="http://localhost:4200/storage-facility/midrand/storage-unit-13"
					class="quick_quote">
					<p>Quick quote</p>
				</div>
			</div>
			<div class="content" (click)="set_index_change(4)"
				[ngStyle]="(style_index!=4)?default_styles:changed_styles">
				<p class="dim" [ngStyle]="(style_index!=4)?default_p_styles:changed_p_styles">2.5 x 4: 10m</p>
				<div *ngIf="style_index==4" class="description">{{description[4]}}</div>

				<div *ngIf="style_index==4" class="quick_quote">
					<p>Quick quote</p>
				</div>
			</div>
			<div class="content" (click)="set_index_change(5)"
				[ngStyle]="(style_index!=5)?default_styles:changed_styles">
				<p class="dim" [ngStyle]="(style_index!=5)?default_p_styles:changed_p_styles"> 3 x 3: 9m</p>
				<div *ngIf="style_index==5" class="description">{{description[5]}}</div>

				<div *ngIf="style_index==5" class="quick_quote">
					<p>Quick quote</p>
				</div>
			</div>
			<div class="content" (click)="set_index_change(6)"
				[ngStyle]="(style_index!=6)?default_styles:changed_styles">
				<p class="dim" [ngStyle]="(style_index!=6)?default_p_styles:changed_p_styles">3,4 x 3,8: 12.92m</p>
				<div *ngIf="style_index==6" class="description">{{description[6]}}</div>

				<div *ngIf="style_index==6" class="quick_quote">
					<p>Quick quote</p>
				</div>
			</div>
		</div>

	</div>
	<div class="category" [ngStyle]="{'border':(show_unit_size3)?'2px solid rgba(13, 135, 79,1)':'1px solid #c5c5c5'}">
		<p (click)="show_unit_size3 = !show_unit_size3" [ngStyle]="{'font-weight':(show_unit_size3)?'600':'400'}">Large
			units</p>
		<div *ngIf="show_unit_size3">

			<div class="content" (click)="set_index_change(7)"
				[ngStyle]="(style_index!=7)?default_styles:changed_styles">
				<p class="dim" [ngStyle]="(style_index!=7)?default_p_styles:changed_p_styles">4 x 4,5: 18m</p>
				<div *ngIf="style_index==7" class="description">{{description[7]}}</div>

				<div *ngIf="style_index==7" class="quick_quote">
					<p>Quick quote</p>
				</div>
			</div>
			<div class="content" (click)="set_index_change(8)"
				[ngStyle]="(style_index!=8)?default_styles:changed_styles">
				<p class="dim" [ngStyle]="(style_index!=8)?default_p_styles:changed_p_styles">4 x 7: 28m</p>
				<div *ngIf="style_index==8" class="description">{{description[8]}}</div>

				<div *ngIf="style_index==8" class="quick_quote">
					<p>Quick quote</p>
				</div>
			</div>
			<div class="content" (click)="set_index_change(9)"
				[ngStyle]="(style_index!=9)?default_styles:changed_styles">
				<p class="dim" [ngStyle]="(style_index!=9)?default_p_styles:changed_p_styles">5 x 6: 36m</p>
				<div *ngIf="style_index==9" class="description">{{description[9]}}</div>

				<div *ngIf="style_index==9" class="quick_quote">
					<p>Quick quote</p>
				</div>
			</div>
			<div class="content" (click)="set_index_change(10)"
				[ngStyle]="(style_index!=10)?default_styles:changed_styles">
				<p class="dim" [ngStyle]="(style_index!=10)?default_p_styles:changed_p_styles">6 x 9: 54m</p>
				<div *ngIf="style_index==10" class="description">{{description[10]}}</div>

				<div *ngIf="style_index==10" class="quick_quote">
					<p>Quick quote</p>
				</div>
			</div>
		</div>
	</div>



</div>
<div *ngIf="agnostic_units" class="arrow" (click)="show_menu=!show_menu"
	[ngStyle]="(show_menu)?default_arrow_style:changed_arrow_style">
	<svg [ngStyle]="(show_menu)?default_svg_style:changed_svg_style" xmlns="http://www.w3.org/2000/svg" width="9.352"
		height="15.765" viewBox="0 0 9.352 15.765">
		<path id="Path_2993" data-name="Path 2993" d="M13247.42-6174.8l6.784,6.784c.5.5-6.784,6.784-6.784,6.784"
			transform="translate(13255.711 -6160.099) rotate(180)" fill="none" stroke="#0d874f" stroke-width="3" />
	</svg>
</div>

<ras-spinner [active]="is_loading" [messages]="['Simulating 3D View']"></ras-spinner>